class Connection {
    // PERMISSIONS
    static get SEND_TO_MOBILE() {return 1};
    static get SEE_TRACKING() {return 2};
    static get SEE_TIMELINE() {return 4};
    static get PLACE_PINS() {return 8};
    static get SUPERVISE() {return 16};
    static get SUPERVISION_REQ() {return 32};
    
    // FLAGS
    static get SYNC() {return 1};

    constructor(list) {
        this._list = list;
    }

    /**
     * 
     * @param {Array} data 
     */
    static fromArray(data, list) {
        let inst = new Connection(list);

        inst._userId = data['other_user_id'];
        inst._userName = data['full_name'];
        inst._yourFlags = data['flags'];
        inst._theirFlags = data['other_flags'];
        inst._status = data['status'];
		inst._otherStatus = data['other_status'];

        return inst;
    }

	get id() {return this._userId;}
	get name() {return this._userName;}

	get isSupervised() {return this._yourFlags & CONNECTION.SUPERVISING;}
	get isSupervisor() {return this._theirFlags & CONNECTION.SUPERVISING;}

    getElem(hasSub) {
        if (this._elem) return this._elem;

        let superIcon;
		if (this._yourFlags & CONNECTION.SUPERVISING) {
			superIcon = span('tooltip i-rg i-supervise me-2', null, null, {'data-tip': _("You are their supervisor"), 'data-pos': 'above-right'});
		}
		else if (this._theirFlags & CONNECTION.SUPERVISING) {
			superIcon = span('tooltip i-rg i-supervise me-2', null, null, {'data-tip': _("They are your supervisor"), 'data-pos': 'above-right'});
		}
		else superIcon = null;
		this.ruleButton = hasSub ?
			btn('btn i-rg i-timer tooltip', null, {
				'click':this.editRules.bind(this)
			}, {
				'data-tip':_("Time restrictions on shared info")
			}) : null;

		if (this._otherStatus == CONNECTION.PENDING) {
			this.buttons = span(null, "Request pending");
		}
		else {
			this.buttons = span(null, [
				label('tooltip', [
					this.syncChk = chk('masked'), icon('phone-sync', 'lg', 'mask')
				], null, { 'data-tip': _("Sync their info with your mobile") }),
				this.teamButton = btn('btn tooltip i-rg i-teams', null, {
					'click': this.showTeamChecklist.bind(this)
				}, {
					'data-pos': 'above-left',
					'data-tip': _("Teams this hero belongs to")
				})
			]);
			
			this.syncChk.checked = this._yourFlags & CONNECTION.SYNC_WITH_MOBILE;
			onEv(this.syncChk, 'change', this.setFlag.bind(this, CONNECTION.SYNC_WITH_MOBILE, this.syncChk));
		}

        this._elem = div('list-row mx-4 align-items-center', [
			div('col-auto', [div('icon', superIcon)]),
            div('col-auto', this._userName),
            div('col-auto ms-auto', [
                this.buttons,
                this.moreButton = btn('btn i-rg i-more-v', null, {
					'click': this._list.showMoreMenu.bind(this._list, this)
				})
            ])
        ]);

        // this.youSeeTimeline.checked = this._yourFlags & Connection.SEE_TIMELINE;
        // this.youSeeTracking.checked = this._yourFlags & Connection.SEE_TRACKING;
        // this.youPlacePins.checked = this._yourFlags & Connection.PLACE_PINS;
        
		// if (this._yourFlags & Connection.SUPERVISE) {
		// 	onEv(this.youSeeTimeline, 'change', this.setPermission.bind(this, Connection.SEE_TIMELINE, this.youSeeTimeline, 1));
		// 	onEv(this.youSeeTracking, 'change', this.setPermission.bind(this, Connection.SEE_TRACKING, this.youSeeTracking, 1));
		// 	onEv(this.youPlacePins, 'change', this.setPermission.bind(this, Connection.PLACE_PINS, this.youPlacePins, 1));
		// }
		// else {
		// 	this.youSeeTimeline.disabled = true;
		// 	this.youSeeTracking.disabled = true;
		// 	this.youPlacePins.disabled = true;
		// }

        // if (hasSub) {
        //     this.theySeeTimeline.checked = this._theirFlags & Connection.SEE_TIMELINE;
        //     this.theySeeTracking.checked = this._theirFlags & Connection.SEE_TRACKING;
        //     this.theyPlacePins.checked = this._theirFlags & Connection.PLACE_PINS;
        
        //     onEv(this.theySeeTimeline, 'change', this.setPermission.bind(this, Connection.SEE_TIMELINE, this.theySeeTimeline, 0));
        //     onEv(this.theySeeTracking, 'change', this.setPermission.bind(this, Connection.SEE_TRACKING, this.theySeeTracking, 0));
        //     onEv(this.theyPlacePins, 'change', this.setPermission.bind(this, Connection.PLACE_PINS, this.theyPlacePins, 0));
    
        // }
        
        return this._elem;
    }

    setFlag(flag, checkbox) {
        let reqData = [
            'userId=' + encodeURI(this._userId),
            'value=' + flag
        ];
        ajg('connection/set-flag', reqData, null, function(reply) {
            if (!!reply.value !== !!checkbox.checked) {
                makeToast(_("Changes not saved!!"));
            }
        });
    }

    setPermission(permission, checkbox, you) {
        let reqData = [
            'userId=' + encodeURI(this._userId),
            'value=' + permission,
            'you=' + ((typeof you !== 'undefined' && you == true) ? 1 : 0)
        ];
        ajg('connection/set-permission', reqData, null, function(reply) {
			if (showError(reply)) {
				checkbox.checked = !checkbox.checked;
				return;
			}
            if (!!reply.value !== !!checkbox.checked) {
				checkbox.checked = reply.value;
                makeToast(_("Changes not saved!!"));
            }
        });
    }

    editRules(ev){
        if (typeof connectionRules === 'undefined' || !connectionRules instanceof ConnectionRuleList) return;
        connectionRules.show(this._userId, this.ruleButton, ev);
    }

	showTeamChecklist(ev) {
		if (typeof teams === 'undefined' || !teams instanceof TeamList) return;
		teams.mapOne(this._userId, this.teamButton, ev);
	}

    /**
     * Remove the connection with this user
     */
    remove() {
		API.delete(`connections/${this.id}`)
		.then(reply => {
			if (showError(reply)) return;
			this._elem.remove();
			this._list.remove(this);
		});
    }

    /**
     * Block the connection with this user
     */
    block() {
// TODO - BLOCK CONNECTIONS
    }
}